import {FC, Suspense} from 'react';
import {Stack} from '@mui/system';
import {ContractRequestsTable} from './contract-requests-table';
import {ContractRequestsSearchField} from './contract-requests-search-field';
import {ContractsSpinner} from '../contracts-spinner';

export const ContractRequests: FC = () => {
  return (
    <Stack spacing={2}>
      <ContractRequestsSearchField />

      <ContractRequestsTable />
    </Stack>
  );
};
